import ProductionQualityInspectionVisual from '@/models/ProductionQualityInspectionVisual/ProductionQualityInspectionVisual';

export default class ProductionQualityInspectionVisualFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.inspectionNumber = '';
		this.workOrderProcessDetailId  = '';
		this.workOrderProcessDetailPart = '';
		this.workOrderExecutionDetailId  = '';
		this.workOrderExecutionDetailWorkOrderProcessDetail = '';
		this.productionDateFrom = '';
		this.productionDateTo = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			inspectionNumber : '0',
			workOrderProcessDetailId : '0',
			workOrderProcessDetailPart : '0',
			workOrderExecutionDetailId : '0',
			workOrderExecutionDetailWorkOrderProcessDetail : '0',
			productionDateFrom : '0',
			productionDateTo : '0',
			partId : '0',
			partPartNumber : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}